import {
  FieldProps,
  FormFieldTypesNames,
} from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { formBuilderActions } from "@common/redux/formBuilder/actions";
import { DataUtility as _ } from "@utils/DataUtility";
import {
  IAdvancedRulesClient,
  IFieldsMap,
  IForm,
  IFormBuilderState,
  IFieldsToHIdeAndShow,
  IPageToHIdeAndShow,
  IModalData,
  submisionType,
} from "@common/redux/formBuilder/interface";
import {
  formInitialStateClient,
  populateNewFieldAndTransformFromServerToClient,
  populateNewSectionAndTransformToClient,
  ruleInitialStateClient,
  transformRuleDataServerToClient,
  subRuleInitialValueServer,
  transformSubRuleDataServerToClient,
  transformFieldRuleDataServerToClient,
  ITransformFieldRuleDataServerToClient,
  updateFieldsToIgnoreAndFieldsMapOnDeleteConditionOrSubRule,
  getItemByIndex,
  getFieldData,
  duplicateSection,
  transformPageRuleDataServerToClient,
  ITransformPageRuleDataServerToClient,
  updatePagesToIgnoreAndPagesMapOnDeleteConditionOrSubRule,
  ITransformFormRuleDataServerToClient,
  transformFormRuleDataServerToClient,
  updateFormFieldsToIgnoreAndFormsMapOnDeleteConditionOrSubRule,
  ITransformSubmissionRuleDataServerToClient,
  transformSubmissionRuleDataServerToClient,
} from "@common/redux/formBuilder/utils";
import {
  IFieldLevelRuleClient,
  IFieldLevelRuleConditionClient,
  IFieldLevelRuleConditionMap,
  IFormLevelRuleConditionClient,
  IFormServer,
  IPageLevelRuleConditionClient,
  ISubmissionLevelRuleConditionClient,
} from "@common/redux/forms/interface";
import {
  generateUniqueId,
  uniqueIdType,
} from "@presentation/FormBuilder/utils";
import { DataMappingUtils } from "@utils/DataMappingUtils";
import { FormModes } from "@presentation/FormBuilder/components/DescriptionField/utils";
export const initialState: IFormBuilderState = {
  activeForm: formInitialStateClient as IForm,
  activeRules: ruleInitialStateClient,
  activeSubformIndex: 0,
  loaders: {
    setActiveForm: false,
    changeFieldPosition: false,
  },
  errors: {
    setActiveForm: "",
    changeFieldPosition: "",
  },
  currentEditModeFieldId: "",
  currentFocusedFieldId: "",
  activeFormIsEditing: false,
  fieldLoaderMap: {},
  updatedHiddenFields: [],
  formLockData: {
    formId: "",
    isFormLocked: {},
    formLockedBy: {},
  },
  formMode: FormModes.view,
  isMultiFormVertical: false,
};

export const formBuilderReducer = (
  state: IFormBuilderState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case formBuilderActions.ADD_NEW_FIELD: {
      const index = action.payload.index;
      const fieldId = action.payload.fieldId;
      const subFormId = action.payload.formId;
      let existingOverviewForm = state.activeForm.overviewForm || [];
      const subFormsMap = state.activeForm.subFormsMap;

      if (!subFormId) {
        const existingFields = existingOverviewForm || [];
        const fieldPosition = index ?? existingFields?.length;
        const updatedFields = [
          ...existingFields.slice(0, fieldPosition),
          fieldId,
          ...existingFields.slice(fieldPosition),
        ];
        existingOverviewForm = updatedFields;
      } else {
        if (subFormsMap[subFormId]) {
          const existingFields = subFormsMap[subFormId].fields || [];
          const fieldPosition = index ?? existingFields?.length;
          const updatedFields = [
            ...existingFields.slice(0, fieldPosition),
            fieldId,
            ...existingFields.slice(fieldPosition),
          ];
          subFormsMap[subFormId].fields = updatedFields;
        }
      }

      const existingFieldMap = state.activeForm.fieldsMap;

      if (existingFieldMap[subFormId]) {
        // it is used to handle add new field inside a section.
        const existingFields = existingFieldMap[subFormId].fields || [];
        const updatedFields = [
          ...existingFields.slice(0, index),
          fieldId,
          ...existingFields.slice(index),
        ];
        existingFieldMap[subFormId].fields = updatedFields;
      }

      const updatedFieldMap = getUpdatedFieldMap(
        [
          {
            localId: action.payload.fieldId,
            isSection: false,
          } as FieldProps,
        ],
        existingFieldMap
      );
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          overviewForm: existingOverviewForm,
          subFormsMap,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }
    case formBuilderActions.SET_FORM_MODE: {
      const mode = action.payload ?? FormModes.view;
      return {
        ...state,
        formMode: mode,
      };
    }
    case formBuilderActions.ADD_NEW_SECTION: {
      const index = action.payload.index;
      const fieldId = action.payload.fieldId;
      const subFormId = action.payload.formId;

      const subFormsMap = state.activeForm.subFormsMap;
      let existingOverviewForm = state.activeForm.overviewForm || [];
      if (!subFormId) {
        const existingFields = existingOverviewForm || [];
        const fieldPosition = index ?? existingFields?.length;
        const updatedFields = [
          ...existingFields.slice(0, fieldPosition),
          fieldId,
          ...existingFields.slice(fieldPosition),
        ];
        existingOverviewForm = updatedFields;
      } else {
        if (subFormsMap[subFormId]) {
          const existingFields = subFormsMap[subFormId].fields || [];
          const fieldPosition = index ?? existingFields?.length;
          const updatedFields = [
            ...existingFields.slice(0, fieldPosition),
            fieldId,
            ...existingFields.slice(fieldPosition),
          ];
          subFormsMap[subFormId].fields = updatedFields;
        }
      }

      const existingFieldMap = state.activeForm.fieldsMap;

      if (existingFieldMap[subFormId]) {
        //to update form section
        const existingFields = existingFieldMap[subFormId].fields || [];
        const updatedFields = [
          ...existingFields.slice(0, index),
          fieldId,
          ...existingFields.slice(index),
        ];
        existingFieldMap[subFormId].fields = updatedFields;
      }

      const updatedFieldMap = getUpdatedFieldMap(
        [
          {
            localId: action.payload.fieldId,
            isSection: true,
            title: "New Section",
          } as FieldProps,
        ],
        existingFieldMap
      );
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          overviewForm: existingOverviewForm,
          subFormsMap,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.SET_MULTI_FORM_VERTICAL: {
      return {
        ...state,
        isMultiFormVertical: action.payload.isVertical,
      };
    }

    case formBuilderActions.ADD_NEW_SUB_FORM: {
      const index = action.payload.index;
      const subFormId = action.payload.formId;

      const existingSubForms = state?.activeForm?.subForms || [];
      // const existingFields = forms || [];
      const updatedForms = [
        ...existingSubForms.slice(0, index + 1),
        subFormId,
        ...existingSubForms.slice(index + 1),
      ];

      const existingSubFormMap = state?.activeForm?.subFormsMap || {};

      const updatedFormMap = getUpdatedFieldMap(
        [
          {
            localId: subFormId,
            title: `Page ${updatedForms.length}`,
            fields: [],
          } as FieldProps,
        ],
        existingSubFormMap
      );
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          subForms: updatedForms,
          subFormsMap: updatedFormMap,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.DELETE_SUB_FORM: {
      const index = action.payload.index;

      const existingSubFormMap = state?.activeForm?.subFormsMap || {};

      const existingSubForms = state?.activeForm?.subForms || [];

      const subFormId = existingSubForms[index];
      const updatedForms = [
        ...existingSubForms.slice(0, index),
        ...existingSubForms.slice(index + 1),
      ];

      delete existingSubFormMap[subFormId];
      const updatedFormMap = { ...existingSubFormMap };
      let isMultipleForm = state?.activeForm?.isMultipleForm || {};
      if (updatedForms?.length == 0) {
        isMultipleForm = false;
      }
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          subForms: updatedForms,
          subFormsMap: updatedFormMap,
          isMultipleForm,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.COPY_FIELD: {
      const index = action.payload.index;
      const newFieldId = action.payload.fieldId;
      const subFormId = action.payload.formId;
      let existingFieldId: string;

      let overviewForm = state.activeForm.overviewForm || [];
      const subFormsMap = state.activeForm.subFormsMap;
      if (!subFormId) {
        const existingFields = overviewForm || [];
        const updatedFields = [
          ...existingFields.slice(0, index + 1),
          newFieldId,
          ...existingFields.slice(index + 1),
        ];
        overviewForm = updatedFields;
        existingFieldId = existingFields[index];
      } else {
        if (subFormsMap[subFormId]) {
          const existingFields = subFormsMap[subFormId].fields || [];
          const updatedFields = [
            ...existingFields.slice(0, index + 1),
            newFieldId,
            ...existingFields.slice(index + 1),
          ];
          subFormsMap[subFormId].fields = updatedFields;
          existingFieldId = existingFields[index];
        }
      }

      const existingFieldMap = state.activeForm.fieldsMap;

      if (existingFieldMap[subFormId]) {
        //to handle copy field in section
        const existingFields = existingFieldMap[subFormId].fields || [];
        const updatedFields = [
          ...existingFields.slice(0, index + 1),
          newFieldId,
          ...existingFields.slice(index + 1),
        ];
        existingFieldMap[subFormId].fields = updatedFields;
        existingFieldId = existingFields[index];
      }
      const existingField: FieldProps = existingFieldMap[existingFieldId];

      const { duplicatedField: fieldTobeCopied, updatedFieldsMap } =
        cloneCoreElement(
          existingField,
          existingFieldMap,
          state.activeForm?.localId
        );

      fieldTobeCopied.localId = newFieldId;

      const updatedFieldMap = getUpdatedFieldMap(
        [fieldTobeCopied],
        updatedFieldsMap
      );

      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          overviewForm,
          subFormsMap,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.DELETE_FIELD: {
      const index = action.payload.index;
      const formId = action.payload.formId;

      const existingFieldMap = state.activeForm.fieldsMap;

      let fieldId: string;
      const subFormsMap = state.activeForm.subFormsMap;
      if (subFormsMap[formId]) {
        const existingFields = subFormsMap[formId].fields || [];
        fieldId = existingFields[index];
        const updatedFields = [
          ...existingFields.slice(0, index),
          ...existingFields.slice(index + 1),
        ];
        subFormsMap[formId].fields = updatedFields;
      }

      if (existingFieldMap[formId]) {
        const existingFields = existingFieldMap[formId].fields || [];
        fieldId = existingFields[index];
        const updatedFields = [
          ...existingFields.slice(0, index),
          ...existingFields.slice(index + 1),
        ];
        existingFieldMap[formId].fields = updatedFields;
      }

      let existingOverviewForm = state.activeForm.overviewForm || [];
      if (!formId) {
        const existingFields = existingOverviewForm || [];
        fieldId = existingFields[index];
        const updatedFields = [
          ...existingFields.slice(0, index),
          ...existingFields.slice(index + 1),
        ];
        existingOverviewForm = updatedFields;
      }

      delete existingFieldMap[fieldId];
      const updatedFieldMap = { ...existingFieldMap };

      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          overviewForm: existingOverviewForm,
          subFormsMap,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }

    //CHANGE_FIELD_TYPE

    case formBuilderActions.UPDATE_FIELD_DATA: {
      const updatedFieldData = action.payload.data;
      const existingFieldMap = state.activeForm.fieldsMap;
      const updatedFieldMap = getUpdatedFieldMap(
        [updatedFieldData],
        existingFieldMap
      );
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }
    case formBuilderActions.UPDATE_FIELDS_MAP: {
      const fieldsMap = action.payload.data;
      const existingFieldMap = state.activeForm.fieldsMap;
      const updatedFieldsMap = { ...existingFieldMap, ...(fieldsMap || {}) };
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: updatedFieldsMap,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.UPDATE_SUB_FORM_DATA: {
      const updatedSubFormData = action.payload.data;
      const existingSubFormMap = state.activeForm.subFormsMap;
      const updatedSubFormMap = getUpdatedFieldMap(
        [updatedSubFormData],
        existingSubFormMap
      );

      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          subFormsMap: updatedSubFormMap,
        },
        activeFormIsEditing: true,
      };
    }
    case formBuilderActions.UPDATE_THEME_ID: {
      const themeId = action.payload.themeId;
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          themeId,
        },
        activeFormIsEditing: true,
      };
    }
    case formBuilderActions.CHANGE_FIELD_TYPE: {
      const updatedFieldData = action.payload.data;
      const existingFieldMap = state.activeForm.fieldsMap;
      const isReplace = true;

      const count = getFieldData(existingFieldMap);

      const updatedFieldDataWithName = {
        ...updatedFieldData,
        title:
          count[updatedFieldData.fieldType] >= 0
            ? `${FormFieldTypesNames[updatedFieldData.fieldType]} ${count[updatedFieldData.fieldType] + 1
            }`
            : `${FormFieldTypesNames[updatedFieldData.fieldType]}`,
      };

      const updatedFieldMap = getUpdatedFieldMap(
        [updatedFieldDataWithName],
        existingFieldMap,
        isReplace
      );

      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }
    case formBuilderActions.UPDATE_DATA_FORM_DATA: {
      const updatedFieldData = action.payload.data;
      return {
        ...state,
        activeForm: updatedFieldData,
      };
    }

    case formBuilderActions.INITIALIZE_FIELD_DATA: {
      const fieldsMap = action.payload.fieldsMap;
      const formIds = action.payload.forms;
      const subFormsMap = action.payload.subFormsMap;
      const overviewForm = action.payload.overviewForm;
      const initialSettings = action.payload.initialSettings;
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          subForms: formIds,
          subFormsMap,
          fieldsMap,
          overviewForm,
          settings: initialSettings,
        },
      };
    }

    case formBuilderActions.UPDATE_FIELD_POSITION: {
      const currentPosition = action.payload.currentPosition;
      const newPosition = action.payload.newPosition;
      const subFormId = action.payload.formId;

      const subFormsMap = state.activeForm.subFormsMap;
      const existingFieldMap = state.activeForm.fieldsMap;
      if (subFormsMap[subFormId]) {
        const existingFields = subFormsMap[subFormId].fields || [];

        [existingFields[currentPosition], existingFields[newPosition]] = [
          existingFields[newPosition],
          existingFields[currentPosition],
        ];
        subFormsMap[subFormId].fields = existingFields;
      }

      if (existingFieldMap[subFormId]) {
        const existingFields = existingFieldMap[subFormId].fields || [];

        [existingFields[currentPosition], existingFields[newPosition]] = [
          existingFields[newPosition],
          existingFields[currentPosition],
        ];
        existingFieldMap[subFormId].fields = existingFields;
      }
      let overviewForm = state.activeForm.overviewForm;
      if (!subFormId) {
        const existingFields = overviewForm || [];

        [existingFields[currentPosition], existingFields[newPosition]] = [
          existingFields[newPosition],
          existingFields[currentPosition],
        ];
        overviewForm = existingFields;
      }
      const updatedFieldMap = { ...existingFieldMap };
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          overviewForm: overviewForm,
          subFormsMap: subFormsMap,
          fieldsMap: updatedFieldMap,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.UPDATE_SUB_FORM_POSITION: {
      const currentPosition = action.payload.currentPosition;
      const newPosition = action.payload.newPosition;
      const existingFields = state.activeForm.subForms || [];

      [existingFields[currentPosition], existingFields[newPosition]] = [
        existingFields[newPosition],
        existingFields[currentPosition],
      ];

      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          subForms: existingFields,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.SET_ACTIVE_FORM: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          setActiveForm: true,
        },
      };
    }
    case formBuilderActions.SET_ACTIVE_FORM_SUCCESS: {
      const formData: IForm = _.cloneDeep(action?.payload?.formData);
      return {
        ...state,
        activeForm: formData,
        loaders: {
          ...state.loaders,
          setActiveForm: false,
        },
      };
    }
    case formBuilderActions.SET_ACTIVE_FORM_FAILURE: {
      const error = action?.payload?.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          setActiveForm: false,
        },
        errors: {
          ...state.errors,
          setActiveForm: error,
        },
      };
    }

    case formBuilderActions.SHOW_FIELD_EDITOR: {
      const fieldId = action.payload?.fieldId || state?.currentEditModeFieldId;
      const showFieldEditor = action?.payload?.showFieldEditor || false;
      const existingFieldMap = state.activeForm.fieldsMap;

      // Object.keys(existingFieldMap).map((key: string) => {
      //   if (key != fieldId) {
      //     existingFieldMap[key].isEditingField = false;
      //   } else {
      //     existingFieldMap[key].isEditingField = isEditingField;
      //   }
      // });

      // if (existingFieldMap[fieldId].isSection) {// not used need to check and remove
      //   const firstFieldKey = existingFieldMap[fieldId].fields[0] || "";
      //   existingFieldMap[firstFieldKey].isEditingField = true;
      // }

      existingFieldMap[fieldId] = {
        ...existingFieldMap[fieldId],
        isEditingField: showFieldEditor,
      };
      const updatedCurrentEditModeFieldId = showFieldEditor ? fieldId : "";
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: existingFieldMap,
        },
        currentEditModeFieldId: updatedCurrentEditModeFieldId,
      };
    }

    case formBuilderActions.FOCUS_FIELD: {
      const { fieldId } = action?.payload;
      const isFieldFocused = action?.payload?.isFieldFocused || false;
      const existingFieldMap = { ...state?.activeForm?.fieldsMap };

      existingFieldMap[fieldId] = {
        ...existingFieldMap[fieldId],
        isFieldFocused: isFieldFocused,
      };
      const updatedCurrentFocusedFieldId = isFieldFocused ? fieldId : "";
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: existingFieldMap,
        },
        currentFocusedFieldId: updatedCurrentFocusedFieldId,
      };
    }

    case formBuilderActions.POPULATE_NEW_FIELD_CONFIG: {
      const { fieldConfig, fieldId } = action.payload;
      const existingFieldMap: IFieldsMap = { ...state.activeForm.fieldsMap };
      const updatedFieldData: FieldProps =
        populateNewFieldAndTransformFromServerToClient(fieldConfig, fieldId);
      existingFieldMap[fieldId] = updatedFieldData;
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: existingFieldMap,
        },
      };
    }

    case formBuilderActions.DOUBLE_PANEL_RULE_INDEX: {
      const { fieldConfig, fieldId } = action.payload;
      const existingFieldMap: IFieldsMap = { ...state.activeForm.fieldsMap };
      const updatedFieldData: FieldProps =
        populateNewFieldAndTransformFromServerToClient(fieldConfig, fieldId);
      existingFieldMap[fieldId] = updatedFieldData;
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: existingFieldMap,
        },
      };
    }

    case formBuilderActions.POPULATE_NEW_SECTION_CONFIG: {
      const { sectionConfig, sectionId } = action.payload;
      const existingFieldMap: IFieldsMap = { ...state.activeForm.fieldsMap };
      const updatedSectionfieldsMapClient =
        populateNewSectionAndTransformToClient(sectionConfig, sectionId);
      const updatedFieldMap: IFieldsMap = {
        ...existingFieldMap,
        ...updatedSectionfieldsMapClient,
      };
      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          fieldsMap: updatedFieldMap,
        },
      };
    }

    case formBuilderActions.CHANGE_FIELD_POSITION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          changeFieldPosition: true,
        },
        errors: {
          ...state.errors,
          changeFieldPosition: "",
        },
      };
    }
    case formBuilderActions.CHANGE_FIELD_POSITION_SUCCESS: {
      return {
        ...state,
        activeForm: action?.payload?.formData,
        loaders: {
          ...state.loaders,
          changeFieldPosition: false,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.CHANGE_FIELD_POSITION_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          changeFieldPosition: false,
        },
        errors: {
          ...state.errors,
          changeFieldPosition: action.payload.error,
        },
      };
    }
    case formBuilderActions.SET_ACTIVE_RULE: {
      const transformedRuleData: IAdvancedRulesClient =
        transformRuleDataServerToClient(action.payload.ruleData);
      return {
        ...state,
        activeRules: transformedRuleData,
      };
    }
    case formBuilderActions.SET_ACTIVE_SUBMISSION_TYPE: {
      const subType: submisionType = action.payload.submissionType;
      return {
        ...state,
        submissionType: subType,
      };
    }

    case formBuilderActions.UPDATE_FIELD_RULE: {
      {
        const position = action.payload?.position || 0;
        const updatedFieldRule = action.payload?.fieldRule || [];
        const existingFieldRules = [...(state?.activeRules?.fieldRules ?? [])];
        const updatedFieldRules = existingFieldRules.map((fieldRule, index) => {
          return position == index ? updatedFieldRule : fieldRule;
        });
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldRules: updatedFieldRules,
          },
        };
      }
    }

    case formBuilderActions.ADD_NEW_FIELD_RULE: {
      {
        const fieldRule = action.payload?.fieldRule || [];
        const { fieldsToIgnore, activeFieldRuleCount, fieldConditionMap } = {
          ...(state.activeRules ?? {}),
        };

        const transformedRuleData: ITransformFieldRuleDataServerToClient =
          transformFieldRuleDataServerToClient(
            fieldRule,
            fieldsToIgnore,
            activeFieldRuleCount,
            fieldConditionMap
          );

        const {
          fieldRuleClient,
          updateFieldsToIgnore,
          updatedActiveFieldRuleCount,
          updatedFieldConditionMap,
        } = transformedRuleData;

        const existingFieldRules = [...(state?.activeRules?.fieldRules ?? [])];
        existingFieldRules.push(fieldRuleClient);
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldRules: existingFieldRules,
            fieldsToIgnore: updateFieldsToIgnore,
            activeFieldRuleCount: updatedActiveFieldRuleCount,
            fieldConditionMap: updatedFieldConditionMap,
          },
        };
      }
    }

    case formBuilderActions.ADD_NEW_PAGE_RULE: {
      {
        const pageRule = action.payload?.pageRule;
        const {
          fieldsToIgnore,
          subFormToIgnore,
          activeFieldRuleCount,
          pageConditionMap,
        } = {
          ...(state.activeRules ?? {}),
        };
        const transformedRuleData: ITransformPageRuleDataServerToClient =
          transformPageRuleDataServerToClient(
            pageRule,
            fieldsToIgnore,
            subFormToIgnore,
            activeFieldRuleCount,
            pageConditionMap
          );

        const {
          pageRuleClient,
          updateFieldsToIgnore,
          updatedActivePageRuleCount,
          updatedPageConditionMap,
        } = transformedRuleData;

        const existingPageRules = [...(state?.activeRules?.pageRules ?? [])];
        existingPageRules.push(pageRuleClient);
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            pageRules: existingPageRules,
            fieldsToIgnore: updateFieldsToIgnore,
            activePageRuleCount: updatedActivePageRuleCount,
            pageConditionMap: updatedPageConditionMap,
          },
        };
      }
    }

    case formBuilderActions.ADD_NEW_FORM_RULE: {
      {
        const formRule = action.payload?.formRule;
        const {
          fieldsToIgnore,
          subFormToIgnore,
          activeFieldRuleCount,
          formConditionMap,
        } = {
          ...(state.activeRules ?? {}),
        };

        const transformedRuleData: ITransformFormRuleDataServerToClient =
          transformFormRuleDataServerToClient(
            formRule,
            fieldsToIgnore,
            subFormToIgnore,
            activeFieldRuleCount,
            formConditionMap
          );

        const {
          formRuleClient,
          updateFormFieldsToIgnore: updateFieldsToIgnore,
          updatedActiveFormRuleCount,
          updatedFormConditionMap,
        } = transformedRuleData;

        const existingFormRules = [...(state?.activeRules?.formRules ?? [])];
        existingFormRules.push(formRuleClient);
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            formRules: existingFormRules,
            fieldsToIgnore: updateFieldsToIgnore,
            activeFormRuleCount: updatedActiveFormRuleCount,
            formConditionMap: updatedFormConditionMap,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_PAGE_RULE: {
      {
        const position = action.payload?.position || 0;
        const updatedPageRule = action.payload?.pageRule || [];
        const existingPageRules = [...(state?.activeRules?.pageRules ?? [])];
        const updatedPageRules = existingPageRules?.map((pageRule, index) => {
          return position == index ? updatedPageRule : pageRule;
        });
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            pageRules: updatedPageRules,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_FORM_RULE: {
      {
        const position = action.payload?.position || 0;
        const updatedFormRule = action.payload?.formRule || [];
        const existingFormRules = [...(state?.activeRules?.formRules ?? [])];

        const updatedFormRules = existingFormRules?.map((formRule, index) => {
          return position == index ? updatedFormRule : formRule;
        });
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            formRules: updatedFormRules,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_FIELD_CONDITION: {
      {
        const fieldCondition: IFieldLevelRuleConditionClient =
          action.payload?.fieldCondition || [];
        const fieldConditionId = fieldCondition?.fieldConditionId;
        const fieldConditionMap = {
          ...(state?.activeRules?.fieldConditionMap ?? {}),
        };
        fieldConditionMap[fieldConditionId] = fieldCondition;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldConditionMap,
          },
        };
      }
    }
    case formBuilderActions.UPDATE_PAGE_CONDITION: {
      {
        const pageCondition: IPageLevelRuleConditionClient =
          action.payload?.pageCondition || [];
        const pageConditionId = pageCondition?.pageConditionId;
        if (!pageCondition?.pageConditionId) {
          pageCondition.pageConditionId = pageConditionId;
        }
        const pageConditionMap = {
          ...(state?.activeRules?.pageConditionMap ?? {}),
        };
        pageConditionMap[pageConditionId] = pageCondition;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            pageConditionMap: pageConditionMap,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_FORM_CONDITION: {
      {
        const formCondition: IFormLevelRuleConditionClient =
          action.payload?.formCondition || [];
        const formConditionId = formCondition?.formConditionId;
        if (!formCondition?.formConditionId) {
          formCondition.formConditionId = formConditionId;
        }
        const formConditionMap = {
          ...(state?.activeRules?.formConditionMap ?? {}),
        };
        formConditionMap[formConditionId] = formCondition;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            formConditionMap: formConditionMap,
          },
        };
      }
    }

    case formBuilderActions.ADD_FIELD_CONDITION: {
      {
        const position = action.payload.position;
        const parentConditionId = action.payload.parentConditionId;
        const fieldConditionData: IFieldLevelRuleConditionClient =
          action.payload.fieldConditionData;
        const fieldConditionId = fieldConditionData?.fieldConditionId;
        const updatedActiveFieldRuleCount =
          state.activeRules.activeFieldRuleCount + 1;
        const updatedFieldConditionData: IFieldLevelRuleConditionClient = {
          ...fieldConditionData,
          conditionName: `R${updatedActiveFieldRuleCount}`,
        };
        const fieldConditionMap = {
          ...(state?.activeRules?.fieldConditionMap ?? {}),
        };
        const fieldsRules = [...(state?.activeRules?.fieldRules || [])];
        const activeFieldRuleIndex = state?.activeRules?.activeFieldRuleIndex;
        const activeFieldData = {
          ...(fieldsRules[activeFieldRuleIndex] ?? {}),
        };
        let updatedFieldRule = fieldsRules;

        fieldConditionMap[fieldConditionId] = updatedFieldConditionData; //conditionMap for new field

        if (parentConditionId) {
          const parentConditionData: IFieldLevelRuleConditionClient =
            fieldConditionMap[parentConditionId];
          const fieldConditionIds =
            parentConditionData?.fieldConditionIds || [];
          const updatedconditions = [
            // parent ConditionIds update
            ...fieldConditionIds.slice(0, position + 1),
            fieldConditionId,
            ...fieldConditionIds.slice(position + 1),
          ];
          const updateParentConditionData = {
            ...parentConditionData,
            fieldConditionIds: updatedconditions,
          };
          fieldConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentField
        } else {
          const fieldConditionIds = activeFieldData?.fieldConditionIds || [];
          const updatedconditions = [
            // parent ConditionIds update
            ...fieldConditionIds.slice(0, position + 1),
            fieldConditionId,
            ...fieldConditionIds.slice(position + 1),
          ];
          const updatedActiveFieldRuleData = {
            ...activeFieldData,
            fieldConditionIds: updatedconditions,
          };

          updatedFieldRule = fieldsRules.map((fieldRuleData, index) => {
            return activeFieldRuleIndex == index
              ? updatedActiveFieldRuleData
              : fieldRuleData;
          });
        }

        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldConditionMap,
            activeFieldRuleCount: updatedActiveFieldRuleCount,
            fieldRules: updatedFieldRule,
          },
        };
      }
    }

    case formBuilderActions.DELETE_FIELD_CONDITION: {
      {
        const parentConditionId = action.payload?.parentConditionId || "";
        const fieldConditionPosition = action.payload?.position ?? 0;
        const fieldConditionMap = {
          ...(state?.activeRules?.fieldConditionMap ?? {}),
        };
        const fieldsRules = [...(state?.activeRules?.fieldRules || [])];
        const activeFieldRuleIndex = state?.activeRules?.activeFieldRuleIndex;
        const fieldsToIgnore = [...(state?.activeRules?.fieldsToIgnore || [])];
        const activeFieldData = {
          ...(fieldsRules[activeFieldRuleIndex] ?? {}),
        };
        let updatedFieldRule = fieldsRules;
        let updatedFieldsToIgnore = fieldsToIgnore;
        if (parentConditionId) {
          const parentConditionData: IFieldLevelRuleConditionClient =
            fieldConditionMap[parentConditionId];
          const fieldConditionIds = parentConditionData?.fieldConditionIds;
          const currentConditionId = getItemByIndex(
            fieldConditionIds,
            fieldConditionPosition
          );
          const updatedconditions = fieldConditionIds.filter((value, index) => {
            return fieldConditionPosition !== index;
          });
          const updateParentConditionData = {
            ...parentConditionData,
            fieldConditionIds: updatedconditions,
          };
          fieldConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentField

          updatedFieldsToIgnore =
            updateFieldsToIgnoreAndFieldsMapOnDeleteConditionOrSubRule(
              fieldsToIgnore,
              fieldConditionMap,
              currentConditionId
            );
        } else {
          const fieldConditionIds = activeFieldData?.fieldConditionIds;
          const currentConditionId = getItemByIndex(
            fieldConditionIds,
            fieldConditionPosition
          );
          const updatedconditions = fieldConditionIds.filter((value, index) => {
            return fieldConditionPosition !== index;
          });
          const updatedActiveFieldRuleData = {
            ...activeFieldData,
            fieldConditionIds: updatedconditions,
          };
          updatedFieldRule = fieldsRules.map((fieldRuleData, index) => {
            return activeFieldRuleIndex == index
              ? updatedActiveFieldRuleData
              : fieldRuleData;
          });

          updatedFieldsToIgnore =
            updateFieldsToIgnoreAndFieldsMapOnDeleteConditionOrSubRule(
              fieldsToIgnore,
              fieldConditionMap,
              currentConditionId
            );
        }
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldConditionMap,
            fieldRules: updatedFieldRule,
            fieldsToIgnore: updatedFieldsToIgnore,
          },
        };
      }
    }

    case formBuilderActions.ADD_PAGE_CONDITION: {
      {
        const position = action.payload.position;
        const parentConditionId = action.payload.parentConditionId;
        const pageConditionData: IPageLevelRuleConditionClient =
          action.payload.pageConditionData;
        const pageConditionId = pageConditionData?.pageConditionId;
        const updatedActivePageRuleCount =
          state.activeRules.activePageRuleCount + 1;
        const updatedPageConditionData: IPageLevelRuleConditionClient = {
          ...pageConditionData,
          conditionName: `R${updatedActivePageRuleCount}`,
        };
        const pageConditionMap = {
          ...(state?.activeRules?.pageConditionMap ?? {}),
        };
        const pagesRules = [...(state?.activeRules?.pageRules || [])];
        const activePageRuleIndex = state?.activeRules?.activePageRuleIndex;
        const activePageData = {
          ...(pagesRules[activePageRuleIndex] ?? {}),
        };
        let updatedPageRule = pagesRules;

        pageConditionMap[pageConditionId] = updatedPageConditionData; //conditionMap for new page

        if (parentConditionId) {
          const parentConditionData: IPageLevelRuleConditionClient =
            pageConditionMap[parentConditionId];
          const pageConditionIds = parentConditionData?.pageConditionIds;
          const updatedconditions = [
            // parent ConditionIds update
            ...pageConditionIds.slice(0, position + 1),
            pageConditionId,
            ...pageConditionIds.slice(position + 1),
          ];
          const updateParentConditionData = {
            ...parentConditionData,
            pageConditionIds: updatedconditions,
          };
          pageConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentPage
        } else {
          const pageConditionIds = activePageData?.pageConditionIds;
          const updatedconditions = [
            // parent ConditionIds update
            ...pageConditionIds.slice(0, position + 1),
            pageConditionId,
            ...pageConditionIds.slice(position + 1),
          ];
          const updatedActivePageRuleData = {
            ...activePageData,
            pageConditionIds: updatedconditions,
          };

          updatedPageRule = pagesRules.map((pageRuleData, index) => {
            return activePageRuleIndex == index
              ? updatedActivePageRuleData
              : pageRuleData;
          });
        }

        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            pageConditionMap,
            activePageRuleCount: updatedActivePageRuleCount,
            pageRules: updatedPageRule,
          },
        };
      }
    }

    case formBuilderActions.ADD_FORM_CONDITION: {
      {
        const position = action.payload.position;
        const parentConditionId = action.payload.parentConditionId;
        const formConditionData: IFormLevelRuleConditionClient =
          action.payload.formConditionData;
        const formConditionId = formConditionData?.formConditionId;
        const updatedActiveFormRuleCount =
          state.activeRules.activeFormRuleCount + 1;
        const updatedFormConditionData: IFormLevelRuleConditionClient = {
          ...formConditionData,
          conditionName: `R${updatedActiveFormRuleCount}`,
        };
        const formConditionMap = {
          ...(state?.activeRules?.formConditionMap ?? {}),
        };
        const formsRules = [...(state?.activeRules?.formRules || [])];
        const activeFormRuleIndex = state?.activeRules?.activeFormRuleIndex;
        const activeFormData = {
          ...(formsRules[activeFormRuleIndex] ?? {}),
        };
        let updatedFormRule = formsRules;

        formConditionMap[formConditionId] = updatedFormConditionData; //conditionMap for new form

        if (parentConditionId) {
          const parentConditionData: IFormLevelRuleConditionClient =
            formConditionMap[parentConditionId];
          const formConditionIds = parentConditionData?.formConditionIds;
          const updatedconditions = [
            // parent ConditionIds update
            ...formConditionIds.slice(0, position + 1),
            formConditionId,
            ...formConditionIds.slice(position + 1),
          ];
          const updateParentConditionData = {
            ...parentConditionData,
            formConditionIds: updatedconditions,
          };
          formConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentForm
        } else {
          const formConditionIds = activeFormData?.formConditionIds;
          const updatedconditions = [
            // parent ConditionIds update
            ...formConditionIds.slice(0, position + 1),
            formConditionId,
            ...formConditionIds.slice(position + 1),
          ];
          const updatedActiveFormRuleData = {
            ...activeFormData,
            formConditionIds: updatedconditions,
          };

          updatedFormRule = formsRules.map((formRuleData, index) => {
            return activeFormRuleIndex == index
              ? updatedActiveFormRuleData
              : formRuleData;
          });
        }

        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            formConditionMap,
            activeFormRuleCount: updatedActiveFormRuleCount,
            formRules: updatedFormRule,
          },
        };
      }
    }

    case formBuilderActions.DELETE_PAGE_CONDITION: {
      {
        const parentConditionId = action.payload?.parentConditionId || "";
        const pageConditionPosition = action.payload?.position ?? 0;
        const pageConditionMap = {
          ...(state?.activeRules?.pageConditionMap ?? {}),
        };
        const pagesRules = [...(state?.activeRules?.pageRules || [])];
        const activePageRuleIndex = state?.activeRules?.activePageRuleIndex;
        const pagesToIgnore = [...(state?.activeRules?.subFormToIgnore || [])];
        const activePageData = {
          ...(pagesRules[activePageRuleIndex] ?? {}),
        };
        let updatedPageRule = pagesRules;
        let updatedPagesToIgnore = pagesToIgnore;
        if (parentConditionId) {
          const parentConditionData: IPageLevelRuleConditionClient =
            pageConditionMap[parentConditionId];
          const pageConditionIds = parentConditionData?.pageConditionIds;
          const currentConditionId = getItemByIndex(
            pageConditionIds,
            pageConditionPosition
          );
          const updatedconditions = pageConditionIds.filter((value, index) => {
            return pageConditionPosition !== index;
          });
          const updateParentConditionData = {
            ...parentConditionData,
            pageConditionIds: updatedconditions,
          };
          pageConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentPage

          updatedPagesToIgnore =
            updatePagesToIgnoreAndPagesMapOnDeleteConditionOrSubRule(
              pagesToIgnore,
              pageConditionMap,
              currentConditionId
            );
        } else {
          const pageConditionIds = activePageData?.pageConditionIds;
          const currentConditionId = getItemByIndex(
            pageConditionIds,
            pageConditionPosition
          );
          const updatedconditions = pageConditionIds.filter((value, index) => {
            return pageConditionPosition !== index;
          });
          const updatedActivePageRuleData = {
            ...activePageData,
            pageConditionIds: updatedconditions,
          };
          updatedPageRule = pagesRules.map((pageRuleData, index) => {
            return activePageRuleIndex == index
              ? updatedActivePageRuleData
              : pageRuleData;
          });

          updatedPagesToIgnore =
            updatePagesToIgnoreAndPagesMapOnDeleteConditionOrSubRule(
              pagesToIgnore,
              pageConditionMap,
              currentConditionId
            );
        }
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            pageConditionMap,
            pageRules: updatedPageRule,
            pagesToIgnore: updatedPagesToIgnore,
          },
        };
      }
    }

    case formBuilderActions.DELETE_FORM_CONDITION: {
      {
        const parentConditionId = action.payload?.parentConditionId || "";
        const formConditionPosition = action.payload?.position ?? 0;
        const formConditionMap = {
          ...(state?.activeRules?.formConditionMap ?? {}),
        };
        const formsRules = [...(state?.activeRules?.formRules || [])];
        const activeFormRuleIndex = state?.activeRules?.activeFormRuleIndex;
        const formFieldsToIgnore = [
          ...(state?.activeRules?.formFieldsToIgnore || []),
        ];
        const activeFormData = {
          ...(formsRules[activeFormRuleIndex] ?? {}),
        };
        let updatedFormRule = formsRules;
        let updatedFormFieldsToIgnore = formFieldsToIgnore;
        if (parentConditionId) {
          const parentConditionData: IFormLevelRuleConditionClient =
            formConditionMap[parentConditionId];
          const formConditionIds = parentConditionData?.formConditionIds;
          const currentConditionId = getItemByIndex(
            formConditionIds,
            formConditionPosition
          );
          const updatedconditions = formConditionIds.filter((value, index) => {
            return formConditionPosition !== index;
          });
          const updateParentConditionData = {
            ...parentConditionData,
            formConditionIds: updatedconditions,
          };
          formConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentForm

          updatedFormFieldsToIgnore =
            updateFormFieldsToIgnoreAndFormsMapOnDeleteConditionOrSubRule(
              formFieldsToIgnore,
              formConditionMap,
              currentConditionId
            );
        } else {
          const formConditionIds = activeFormData?.formConditionIds;
          const currentConditionId = getItemByIndex(
            formConditionIds,
            formConditionPosition
          );
          const updatedconditions = formConditionIds.filter((value, index) => {
            return formConditionPosition !== index;
          });
          const updatedActiveFormRuleData = {
            ...activeFormData,
            formConditionIds: updatedconditions,
          };
          updatedFormRule = formsRules.map((formRuleData, index) => {
            return activeFormRuleIndex == index
              ? updatedActiveFormRuleData
              : formRuleData;
          });

          updatedFormFieldsToIgnore =
            updateFormFieldsToIgnoreAndFormsMapOnDeleteConditionOrSubRule(
              formFieldsToIgnore,
              formConditionMap,
              currentConditionId
            );
        }
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            formConditionMap,
            formRules: updatedFormRule,
            formFieldsToIgnore: updatedFormFieldsToIgnore,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_FIELDS_TO_IGNORE: {
      {
        const oldFieldId = action.payload?.oldFieldId || "";
        const newFieldId = action.payload?.newFieldId || "";
        const fieldsToIgnore = [...(state?.activeRules?.fieldsToIgnore ?? [])];
        const updatedFieldsToIgnore = fieldsToIgnore.filter((value, index) => {
          return value !== oldFieldId;
        });
        updatedFieldsToIgnore.push(newFieldId);

        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldsToIgnore: updatedFieldsToIgnore,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_PAGES_TO_IGNORE: {
      {
        const oldPageId = action.payload?.oldPageId || "";
        const newPageId = action.payload?.newPageId || "";
        const subFormToIgnore = [
          ...(state?.activeRules?.subFormToIgnore ?? []),
        ];
        const updatedPagesToIgnore = subFormToIgnore.filter((value, index) => {
          return value !== oldPageId;
        });
        updatedPagesToIgnore.push(newPageId);
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            subFormToIgnore: updatedPagesToIgnore,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_FORM_FIELDS_TO_IGNORE: {
      {
        const oldFormFieldId = action.payload?.oldFormFieldId || "";
        const newFormFieldId = action.payload?.newFormFieldId || "";
        const formFieldsToIgnore = [
          ...(state?.activeRules?.formFieldsToIgnore ?? []),
        ];
        const updatedFormFieldsToIgnore = formFieldsToIgnore.filter(
          (value, index) => {
            return value !== oldFormFieldId;
          }
        );
        updatedFormFieldsToIgnore.push(newFormFieldId);
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            formFieldsToIgnore: updatedFormFieldsToIgnore,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_FIELDS_USED_IN_ACTION: {
      {
        const oldFieldId = action.payload?.oldFieldId || "";
        const newFieldId = action.payload?.newFieldId || "";
        const fieldRules: IFieldLevelRuleClient[] = [
          ...(state.activeRules?.fieldRules ?? []),
        ];
        const activeFieldRuleIndex =
          state.activeRules.activeFieldRuleIndex || 0;
        const activeFieldRule: IFieldLevelRuleClient =
          fieldRules[activeFieldRuleIndex];
        const fieldsUsedInAction: string[] =
          activeFieldRule?.fieldsUsedInAction || [];
        const updatedFieldsUsedInAction = fieldsUsedInAction.filter(
          (value, index) => {
            return value !== oldFieldId;
          }
        );
        updatedFieldsUsedInAction.push(newFieldId);
        const updatedActiveFieldRule: IFieldLevelRuleClient = {
          ...activeFieldRule,
          fieldsUsedInAction: updatedFieldsUsedInAction,
        };
        const updatedFieldRule = fieldRules.map((fieldRuleData, index) => {
          return activeFieldRuleIndex == index
            ? updatedActiveFieldRule
            : fieldRuleData;
        });
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldRules: updatedFieldRule,
          },
        };
      }
    }

    case formBuilderActions.ADD_NEW_SUB_RULE: {
      {
        const position = action.payload.position;
        const parentConditionId = action.payload.parentConditionId;
        const fieldConditionMap = {
          ...(state?.activeRules?.fieldConditionMap ?? {}),
        };
        const {
          fieldConditionMap: updatedfieldConditionMap,
          activeFieldRuleCount: updatedActiveFieldRuleCount,
          subRuleId,
        }: {
          fieldConditionMap: IFieldLevelRuleConditionMap;
          activeFieldRuleCount: number;
          subRuleId: string;
        } = transformSubRuleDataServerToClient(
          subRuleInitialValueServer,
          fieldConditionMap,
          state?.activeRules?.activeFieldRuleCount
        );
        const fieldsRules = [...(state?.activeRules?.fieldRules || [])];
        const activeFieldRuleIndex = state?.activeRules?.activeFieldRuleIndex;
        const activeFieldData = {
          ...(fieldsRules[activeFieldRuleIndex] ?? {}),
        };
        let updatedFieldRule = fieldsRules;

        if (parentConditionId) {
          //create separate functions for these ones.
          const parentConditionData =
            updatedfieldConditionMap[parentConditionId];
          const parentFieldConditionsIds =
            parentConditionData?.fieldConditionIds;

          const updatedFieldConditionIds = [
            ...parentFieldConditionsIds.slice(0, position + 1),
            subRuleId,
            ...parentFieldConditionsIds.slice(position + 1),
          ];
          const updatedParentConditionData = {
            ...parentConditionData,
            fieldConditionIds: updatedFieldConditionIds,
          };
          updatedfieldConditionMap[parentConditionId] =
            updatedParentConditionData;
        } else {
          const fieldConditionIds = activeFieldData?.fieldConditionIds || [];
          const updatedconditions = [
            // parent ConditionIds update
            ...fieldConditionIds.slice(0, position + 1),
            subRuleId,
            ...fieldConditionIds.slice(position + 1),
          ];
          const updatedActiveFieldRuleData = {
            ...activeFieldData,
            fieldConditionIds: updatedconditions,
          };

          updatedFieldRule = fieldsRules.map((fieldRuleData, index) => {
            return activeFieldRuleIndex == index
              ? updatedActiveFieldRuleData
              : fieldRuleData;
          });
        }
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldConditionMap: updatedfieldConditionMap,
            activeFieldRuleCount: updatedActiveFieldRuleCount,
            fieldRules: updatedFieldRule,
          },
        };
      }
    }

    case formBuilderActions.SET_ACTIVE_FIELD_RULE_INDEX: {
      {
        const activeFieldRuleIndex = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            activeFieldRuleIndex: activeFieldRuleIndex,
          },
        };
      }
    }
    case formBuilderActions.SET_ACTIVE_PAGE_RULE_INDEX: {
      {
        const activePageRuleIndex = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            activePageRuleIndex: activePageRuleIndex,
          },
        };
      }
    }
    case formBuilderActions.SET_ACTIVE_FORM_RULE_INDEX: {
      {
        const activeFormRuleIndex = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            activeFormRuleIndex: activeFormRuleIndex,
          },
        };
      }
    }

    case formBuilderActions.VALIDATE_FIELD_RULE: {
      return {
        ...state,
      };
    }

    case formBuilderActions.SET_FIELD_TO_SHOW_AND_HIDE: {
      {
        const fieldsToHideAndShow: IFieldsToHIdeAndShow = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            fieldsToHideAndShow,
          },
        };
      }
    }

    case formBuilderActions.SET_PAGE_TO_SHOW_AND_HIDE: {
      {
        const pageToHideAndShow: IPageToHIdeAndShow = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            pageToHideAndShow,
          },
        };
      }
    }

    case formBuilderActions.SET_MODAL_DATA: {
      {
        const modalData: IModalData = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            modalData,
          },
        };
      }
    }

    case formBuilderActions.COPY_SECTION: {
      const index = action.payload.index;
      const newSectionId = action.payload.newSectionId;
      const parentFormId = action.payload.parentFormId;
      const formId = action.payload.formId;
      let existingFieldId: string;

      let overviewForm = state.activeForm.overviewForm || [];
      const subFormsMap = state.activeForm.subFormsMap;
      if (!parentFormId) {
        const existingFields = overviewForm || [];
        const updatedFields = [
          ...existingFields.slice(0, index + 1),
          newSectionId,
          ...existingFields.slice(index + 1),
        ];
        overviewForm = updatedFields;
        existingFieldId = existingFields[index];
      } else {
        if (subFormsMap[parentFormId]) {
          const existingFields = subFormsMap[parentFormId].fields || [];
          const updatedFields = [
            ...existingFields.slice(0, index + 1),
            newSectionId,
            ...existingFields.slice(index + 1),
          ];
          subFormsMap[parentFormId].fields = updatedFields;
          existingFieldId = existingFields[index];
        }
      }

      const existingFieldMap = state.activeForm.fieldsMap;

      if (existingFieldMap[parentFormId]) {
        //to handle copy field in section
        const existingFields = existingFieldMap[parentFormId].fields || [];
        const updatedFields = [
          ...existingFields.slice(0, index + 1),
          newSectionId,
          ...existingFields.slice(index + 1),
        ];
        existingFieldMap[parentFormId].fields = updatedFields;
        existingFieldId = existingFields[index];
      }
      const existingSectionData: FieldProps = existingFieldMap[existingFieldId];
      const updatedFieldsMap = duplicateSection(
        existingSectionData,
        existingFieldMap,
        formId,
        newSectionId
      );

      return {
        ...state,
        activeForm: {
          ...state.activeForm,
          overviewForm,
          subFormsMap,
          fieldsMap: updatedFieldsMap,
        },
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.UPDATE_ACTIVE_SUBFORM: {
      return {
        ...state,
        activeSubformIndex: action.payload,
        activeForm: {
          ...state.activeForm,
        },
      };
    }

    case formBuilderActions.AUTO_SAVE_FORM_LOCALLY: {
      return {
        ...state,
      };
    }

    case formBuilderActions.SET_AUTO_SAVED_FORM_TO_FORMBUILDER: {
      const formData: IForm = action?.payload?.formData;
      return {
        ...state,
        activeForm: formData,
        activeFormIsEditing: true,
      };
    }

    case formBuilderActions.SET_FORM_IS_EDITING: {
      return {
        ...state,
        activeFormIsEditing: action?.payload?.isEditing || false,
      };
    }

    case formBuilderActions.ADD_SUBMISSION_CONDITION: {
      {
        const position = action.payload.position;
        const parentConditionId = action.payload.parentConditionId;
        const submissionConditionData: ISubmissionLevelRuleConditionClient =
          action.payload.submissionConditionData;
        const submissionConditionId =
          submissionConditionData?.submissionConditionId;
        const updatedActiveSubmissionRuleCount =
          state.activeRules.activeSubmissionRuleCount + 1;
        const updatedSubmissionConditionData: ISubmissionLevelRuleConditionClient =
        {
          ...submissionConditionData,
          conditionName: `R${updatedActiveSubmissionRuleCount}`,
        };
        const submissionConditionMap = {
          ...(state?.activeRules?.submissionConditionMap ?? {}),
        };
        const submissionsRules = [
          ...(state?.activeRules?.submissionRules || []),
        ];
        const activeSubmissionRuleIndex =
          state?.activeRules?.activeSubmissionRuleIndex;
        const activeSubmissionData = {
          ...(submissionsRules[activeSubmissionRuleIndex] ?? {}),
        };
        let updatedSubmissionRule = submissionsRules;

        submissionConditionMap[submissionConditionId] =
          updatedSubmissionConditionData; //conditionMap for new submission

        if (parentConditionId) {
          const parentConditionData: ISubmissionLevelRuleConditionClient =
            submissionConditionMap[parentConditionId];
          const submissionConditionIds =
            parentConditionData?.submissionConditionIds;
          const updatedconditions = [
            // parent ConditionIds update
            ...submissionConditionIds.slice(0, position + 1),
            submissionConditionId,
            ...submissionConditionIds.slice(position + 1),
          ];
          const updateParentConditionData = {
            ...parentConditionData,
            submissionConditionIds: updatedconditions,
          };
          submissionConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentSubmission
        } else {
          const submissionConditionIds =
            activeSubmissionData?.submissionConditionIds;
          const updatedconditions = [
            // parent ConditionIds update
            ...submissionConditionIds.slice(0, position + 1),
            submissionConditionId,
            ...submissionConditionIds.slice(position + 1),
          ];
          const updatedActiveSubmissionRuleData = {
            ...activeSubmissionData,
            submissionConditionIds: updatedconditions,
          };

          updatedSubmissionRule = submissionsRules.map(
            (submissionRuleData, index) => {
              return activeSubmissionRuleIndex == index
                ? updatedActiveSubmissionRuleData
                : submissionRuleData;
            }
          );
        }

        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            submissionConditionMap,
            activeSubmissionRuleCount: updatedActiveSubmissionRuleCount,
            submissionRules: updatedSubmissionRule,
          },
        };
      }
    }

    case formBuilderActions.DELETE_SUBMISSION_CONDITION: {
      {
        const parentConditionId = action.payload?.parentConditionId || "";
        const submissionConditionPosition = action.payload?.position ?? 0;
        const submissionConditionMap = {
          ...(state?.activeRules?.submissionConditionMap ?? {}),
        };
        const submissionsRules = [
          ...(state?.activeRules?.submissionRules || []),
        ];
        const activeSubmissionRuleIndex =
          state?.activeRules?.activeSubmissionRuleIndex;
        const activeSubmissionData = {
          ...(submissionsRules[activeSubmissionRuleIndex] ?? {}),
        };
        let updatedSubmissionRule = submissionsRules;
        if (parentConditionId) {
          const parentConditionData: ISubmissionLevelRuleConditionClient =
            submissionConditionMap[parentConditionId];
          const submissionConditionIds =
            parentConditionData?.submissionConditionIds;
          const updatedconditions = submissionConditionIds.filter(
            (value, index) => {
              return submissionConditionPosition !== index;
            }
          );
          const updateParentConditionData = {
            ...parentConditionData,
            submissionConditionIds: updatedconditions,
          };
          submissionConditionMap[parentConditionId] = updateParentConditionData; //conditionMap Update for ParentSubmission
        } else {
          const submissionConditionIds =
            activeSubmissionData?.submissionConditionIds;
          const updatedconditions = submissionConditionIds.filter(
            (value, index) => {
              return submissionConditionPosition !== index;
            }
          );
          const updatedActiveSubmissionRuleData = {
            ...activeSubmissionData,
            submissionConditionIds: updatedconditions,
          };
          updatedSubmissionRule = submissionsRules.map(
            (submissionRuleData, index) => {
              return activeSubmissionRuleIndex == index
                ? updatedActiveSubmissionRuleData
                : submissionRuleData;
            }
          );
        }
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            submissionConditionMap,
            submissionRules: updatedSubmissionRule,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_SUBMISSION_CONDITION: {
      {
        const submissionCondition: ISubmissionLevelRuleConditionClient =
          action.payload?.submissionCondition || [];
        const submissionConditionId =
          submissionCondition?.submissionConditionId;
        if (!submissionCondition?.submissionConditionId) {
          submissionCondition.submissionConditionId = submissionConditionId;
        }
        const submissionConditionMap = {
          ...(state?.activeRules?.submissionConditionMap ?? {}),
        };
        submissionConditionMap[submissionConditionId] = submissionCondition;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            submissionConditionMap: submissionConditionMap,
          },
        };
      }
    }

    case formBuilderActions.ADD_NEW_SUBMISSION_RULE: {
      {
        const submissionRule = action.payload?.submissionRule;
        const { activeFieldRuleCount, submissionConditionMap } = {
          ...(state.activeRules ?? {}),
        };
        const transsubmissionedRuleData: ITransformSubmissionRuleDataServerToClient =
          transformSubmissionRuleDataServerToClient(
            submissionRule,
            activeFieldRuleCount,
            submissionConditionMap
          );

        const {
          submissionRuleClient,
          updatedActiveSubmissionRuleCount,
          updatedSubmissionConditionMap,
        } = transsubmissionedRuleData;

        const existingSubmissionRules = [
          ...(state?.activeRules?.submissionRules ?? []),
        ];
        existingSubmissionRules.push(submissionRuleClient);
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            submissionRules: existingSubmissionRules,
            activeSubmissionRuleCount: updatedActiveSubmissionRuleCount,
            submissionConditionMap: updatedSubmissionConditionMap,
          },
        };
      }
    }

    case formBuilderActions.UPDATE_SUBMISSION_RULE: {
      {
        const position = action.payload?.position || 0;
        const updatedSubmissionRule = action.payload?.submissionRule || [];
        const existingSubmissionRules = [
          ...(state?.activeRules?.submissionRules ?? []),
        ];
        const updatedSubmissionRules = existingSubmissionRules?.map(
          (submissionRule, index) => {
            return position == index ? updatedSubmissionRule : submissionRule;
          }
        );
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            submissionRules: updatedSubmissionRules,
          },
        };
      }
    }

    case formBuilderActions.SET_ACTIVE_SUBMISSION_RULE_INDEX: {
      {
        const activeSubmissionRuleIndex = action.payload;
        return {
          ...state,
          activeRules: {
            ...state.activeRules,
            activeSubmissionRuleIndex: activeSubmissionRuleIndex,
          },
        };
      }
    }
    case formBuilderActions.SET_FIELD_LOADER_MAP: {
      {
        const fieldLoaderMap = action.payload;
        const updatedFieldLoaderMap = {
          ...state.fieldLoaderMap,
          ...fieldLoaderMap,
        };
        return {
          ...state,
          fieldLoaderMap: updatedFieldLoaderMap,
        };
      }
    }

    case formBuilderActions.SET_HIDDEN_FIELD: {
      return {
        ...state,
        updatedHiddenFields: action.payload.updatedHiddenFields,
      };
    }

    case formBuilderActions.GET_SIGNATURE_FORM_FILES: {
      return {
        ...state,
        errors: { ...state.errors, fetchFile: "" },
      };
    }

    case formBuilderActions.ONLOAD_UPDATE_FORM_LOCK_DATA: {
      const formId = action.payload.formLockData.formId;

      state.formLockData = {
        ...state.formLockData,
        isFormLocked: {
          ...state.formLockData.isFormLocked,
          [formId]: action.payload.formLockData.isFormLocked[formId],
        },
        formLockedBy: {
          ...state.formLockData.formLockedBy,
          [formId]: action.payload.formLockData.formLockedBy[formId],
        },
      };
      return state;
    }

    case formBuilderActions.UPDATE_FORM_LOCK_DATA: {
      const formId = action.payload.formLockData.formId;

      state.formLockData = {
        ...state.formLockData,
        isFormLocked: {
          ...state.formLockData.isFormLocked,
          [formId]: action.payload.formLockData.isFormLocked[formId],
        },
        formLockedBy: {
          ...state.formLockData.formLockedBy,
          [formId]: action.payload.formLockData.formLockedBy[formId],
        },
      };
      return state;
    }

    default:
      return { ...state };
  }
};

const getUpdatedFieldMap = (
  newFields: FieldProps[],
  existingFieldMap: any,
  isReplace?: boolean
) => {
  newFields.forEach((field: FieldProps) => {
    const fieldId = field.localId;
    const existingField = existingFieldMap[fieldId];
    existingFieldMap[fieldId] =
      existingField && !isReplace ? { ...existingField, ...field } : field;
  });

  return { ...existingFieldMap };
};

const cloneCoreElement = (
  existingField: FieldProps,
  existingFieldMap: IFieldsMap,
  formId: string
): {
  duplicatedField: FieldProps;
  updatedFieldsMap: IFieldsMap;
} => {
  const duplicatedField: FieldProps = _.cloneDeep(existingField);
  const updatedFieldsMap: IFieldsMap = existingFieldMap;
  if (duplicatedField?.fields && duplicatedField?.fields.length > 0) {
    const copiedFields = duplicatedField?.fields?.map((fieldId: string) => {
      const existingField = existingFieldMap[fieldId];
      const newFieldId = `_${formId}_field_id_${DataMappingUtils.generateUuidv4()}`;
      const duplicatedField: FieldProps = _.cloneDeep(existingField);
      duplicatedField.localId = newFieldId;
      updatedFieldsMap[newFieldId] = duplicatedField;
      return newFieldId;
    });
    duplicatedField.fields = copiedFields;
  }

  return { duplicatedField: duplicatedField, updatedFieldsMap };
};
